import { Component, Inject, Vue } from "vue-property-decorator";
import AlertService from "@/shared/alert/alert.service";
import BaseComponent from "@/presentation/BaseComponent";
import menuDefault from "./menu";
@Component
export default class AlertMixin extends BaseComponent {
  @Inject("alertService") protected alertService: () => AlertService;

  public dismissCountDown: number = this.$store.getters.dismissCountDown;
  public dismissSecs: number = this.$store.getters.dismissSecs;
  public alertType: string = this.$store.getters.alertType;
  public alertMessage: any = this.$store.getters.alertMessage;
  public menuDefault: Array<any> = menuDefault;
  public getAlertFromStore() {
    this.dismissCountDown = this.$store.getters.dismissCountDown;
    this.dismissSecs = this.$store.getters.dismissSecs;
    this.alertType = this.$store.getters.alertType;
    this.alertMessage = this.$store.getters.alertMessage;
  }
  public demomixis() {
    console.log("demomixis", this.menuDefault);
  }
  public countDownChanged(dismissCountDown: number) {
    this.alertService().countDownChanged(dismissCountDown);
    this.getAlertFromStore();
  }
}
